const API_ENDPOINT = "https://todona-api.surawit.com/api/";
const SITE_KEY = "6LfCkawaAAAAAL4pUFgWI04jhrCavJAWC_v8_sqi";

export { API_ENDPOINT, SITE_KEY };
